"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Sat Oct 13 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../../core/utils/index");

var CompetitorReferentialPriceConverter_1 = require("../../../price-calculation/conversions/CompetitorReferentialPriceConverter");

var ProductPriceConverter_1 = require("../../../product/conversions/ProductPriceConverter");

var CRPFlag_1 = require("../../model/CRPFlag");

var CRPDTO_1 = require("../../model/dto/CRPDTO");

var CRPDTOConverter_1 = require("./CRPDTOConverter");
/**
 * Implementation of CRPDTOConverter
 *
 * @author RV
 */


var CRPDTOConverterImpl =
/*#__PURE__*/
function (_CRPDTOConverter_1$CR) {
  _inherits(CRPDTOConverterImpl, _CRPDTOConverter_1$CR);

  function CRPDTOConverterImpl(competitorReferentialPriceConverter, productPriceConverter) {
    var _this;

    _classCallCheck(this, CRPDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CRPDTOConverterImpl).call(this));
    _this.competitorReferentialPriceConverter = competitorReferentialPriceConverter;
    _this.productPriceConverter = productPriceConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CRPDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new CRPDTO_1.CRPDTO(source.internalProductId, source.competitorId, source.priceZoneId, source.actualPrice ? conversions.asObject(source, 'actualPrice', function (actualPrice) {
        return _this2.competitorReferentialPriceConverter.toObject(actualPrice, conversions);
      }) : null, source.newPrice ? conversions.asObject(source, 'newPrice', function (newPrice) {
        return _this2.competitorReferentialPriceConverter.toObject(newPrice, conversions);
      }) : null, CRPDTO_1.CRPDTO.schema.internalVsCompetitorReferencePriceChangeIndex.valueOf(index_1.Utils.isValueMissing(source.internalVsCompetitorReferencePriceChangeIndex) ? null : conversions.toBigNumber(source.internalVsCompetitorReferencePriceChangeIndex)), conversions.asFlagSet(source.flags, CRPFlag_1.CRPFlag), source.internalRegularPrice ? this.productPriceConverter.toObject(source.internalRegularPrice, conversions) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        internalProductId: source.internalProductId,
        competitorId: source.competitorId,
        priceZoneId: source.priceZoneId,
        actualPrice: source.actualPrice ? conversions.asObject(source, 'actualPrice', function (actualPrice) {
          return _this3.competitorReferentialPriceConverter.toDocument(actualPrice, conversions);
        }) : null,
        newPrice: source.newPrice ? conversions.asObject(source, 'newPrice', function (newPrice) {
          return _this3.competitorReferentialPriceConverter.toDocument(newPrice, conversions);
        }) : null,
        internalVsCompetitorReferencePriceChangeIndex: index_1.Utils.isValueMissing(source.internalVsCompetitorReferencePriceChangeIndex) ? null : conversions.fromBigNumber(source.internalVsCompetitorReferencePriceChangeIndex),
        flags: source.flags ? source.flags.serialize() : null,
        internalRegularPrice: source.internalRegularPrice ? this.productPriceConverter.toDocument(source.internalRegularPrice, conversions) : null
      });
      return result;
    }
  }]);

  return CRPDTOConverterImpl;
}(CRPDTOConverter_1.CRPDTOConverter);

CRPDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [CompetitorReferentialPriceConverter_1.CompetitorReferentialPriceConverter, ProductPriceConverter_1.ProductPriceConverter])], CRPDTOConverterImpl);
exports.CRPDTOConverterImpl = CRPDTOConverterImpl;